<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
html,
body,
#app {
  height: 100%;
  margin: 0;
  padding: 0;
  zoom: 115%;
}

#app {
  font-family: Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;

  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
}

@media (max-width: 768px) {
  html,
  body,
  #app {
    height: 100%;
    margin: 0;
    padding: 0;
    zoom: 100%;
  }
}
</style>
